import { render, staticRenderFns } from "./RegisterPhoneModal.vue?vue&type=template&id=6e074709&scoped=true&"
import script from "./RegisterPhoneModal.vue?vue&type=script&lang=js&"
export * from "./RegisterPhoneModal.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPhoneModal.vue?vue&type=style&index=0&id=6e074709&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e074709",
  null
  
)

export default component.exports